import { useReducer } from 'react';
import { ThemeStateContext, ThemesDispatchContext } from './ThemeContext';
import { ThemeState } from './ThemeContext.types';
import { themesReducer } from './ThemeContext.reducer';
import { getCurriculums } from '@insync-students-constants/curriculum';
export function ThemesContextProvider({
  children
}) {
  const themeList = getCurriculums();
  const [state, dispatchContext] = useReducer(themesReducer, {
    theme: {
      list: themeList,
      selected: themeList[0]
    } as ThemeState
  });
  return <ThemeStateContext.Provider value={state}>
      <ThemesDispatchContext.Provider value={dispatchContext}>
        {children}
      </ThemesDispatchContext.Provider>
    </ThemeStateContext.Provider>;
}